import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Button from '../../components/ButtonProgress';
import DeleteIcon from '@material-ui/icons/Delete';
import BlockIcon from '@material-ui/icons/Block';

import { actions } from '../../services/userProfile';

const styled = withStyles(theme => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 300,
      margin: '0px auto'
    },
    actionBtn: {
      marginBottom: 20
    },
    actionIcon: {
      position: 'absolute',
      left: 10
    }
  };
});

class TabActions extends React.Component {
  state = {
    loadingBlock: false,
    loadingDelete: false,
    loadingRestore: false
  };

  blockAccount = async () => {
    this.setState({ loadingBlock: true });
    await this.props.actions.updateUserStatus('blocked');
    this.setState({ loadingBlock: false });
  };
  deleteAccount = async () => {
    this.setState({ loadingDelete: true });
    await this.props.actions.updateUserStatus('deleted');
    this.setState({ loadingDelete: false });
  };
  restoreAccount = async () => {
    this.setState({ loadingRestore: true });
    await this.props.actions.updateUserStatus('active');
    this.setState({ loadingRestore: false });
  };

  render() {
    const { data, classes } = this.props;

    const blockDisabled = data.status === 'blocked';
    const deleteDisabled =
      data.status === 'deleted' || data.status === 'blocked';
    const restoreDisabled = data.status === 'active';

    return (
      <div className={classes.container}>
        <Button
          variant="outlined"
          className={classes.actionBtn}
          disabled={restoreDisabled || this.state.loadingRestore}
          loading={this.state.loadingRestore}
          onClick={this.restoreAccount}
        >
          Restore
        </Button>
        <Button
          variant="outlined"
          className={classes.actionBtn}
          disabled={blockDisabled || this.state.loadingBlock}
          loading={this.state.loadingBlock}
          onClick={this.blockAccount}
        >
          <BlockIcon className={classes.actionIcon} /> Block
        </Button>
        <Button
          variant="outlined"
          className={classes.actionBtn}
          disabled={deleteDisabled || this.state.loadingDelete}
          loading={this.state.loadingDelete}
          onClick={this.deleteAccount}
        >
          <DeleteIcon className={classes.actionIcon} /> Delete
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.userProfile.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    updateUserStatus: status => dispatch(actions.updateUserStatus(status))
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(TabActions))
);
